<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <div class="label">
          所属机构
        </div>
        <el-select
          v-model="searchForm.agencyId"
          placeholder="请选择所属机构"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in agencyList"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
        <div class="label">
          状态
        </div>
        <el-select
          v-model="searchForm.valid"
          placeholder="请选择状态"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in counselorValidList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <div class="label">
          绑定课程
        </div>
        <el-select
          v-model="searchForm.courseClassId"
          placeholder="请选择课程分类"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in courseList"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="r">
        <el-input
          v-model="searchForm.counselorUserRealName"
          placeholder="请输入辅导员姓名"
          @keyup.enter.native="getList()"
        >
          <el-button
            slot="append"
            type="primary"
            @click="getList()"
          >
            搜索
          </el-button>
        </el-input>
        <el-button
          type="primary"
          @click="creatOrEdit"
        >
          新建辅导员
        </el-button>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :pagination="true"
      :table-column="tableColumn"
      @changeBypagination="tableHandle"
      @sortChange="sortChange"
      @buttonClick="buttonClick"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import types, {
  counselorValidList,
} from '@/config';

export default {
  name: 'Home',
  components: {
    dataTable,
  },
  data() {
    return {
      counselorValidList,
      courseList: [],
      agencyList: [],
      tabelData: {},
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        agencyId: '', // 所属机构id
        courseClassId: '',
        sortType: null,
        valid: '',
        counselorUserRealName: '', // 辅导员姓名搜索
      },
      tableColumn: [
        {
          key: 'counselorUserRealName',
          label: '辅导员姓名',
          width: '80px',
          dataType: 'text',
        },
        {
          key: 'counselorMobilePhone',
          label: '手机号码',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'bindCourseNames',
          label: '绑定课程',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'bindAgencyNames',
          label: '所属机构',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'valid',
          label: '状态',
          width: 'auto',
          dataType: 'component',
          renderProps: { [types.COUNSELOR_ENABLE]: '启用', [types.COUNSELOR_DISABLE]: '禁用', successKey: types.COUNSELOR_ENABLE },
          render: () => 'status',
        },
        {
          key: 'isCheckVideo',
          label: '审核权限',
          width: 'auto',
          dataType: 'component',
          renderProps: { [types.COUNSELOR_CHECKVIDEO]: '已开启', [types.COUNSELOR_NOCHECKVIDEO]: '关闭', successKey: types.COUNSELOR_CHECKVIDEO },
          render: () => 'status',
        },
        {
          key: 'qualificationPic',
          label: '资质照片',
          width: '120px',
          dataType: 'component',
          render: () => 'image',
        },
        {
          key: 'certificatePic',
          label: '讲师证/教师资格证',
          width: '120px',
          dataType: 'component',
          render: () => 'image',
        },
        {
          key: 'skillsPic',
          label: '技能证书',
          width: '120px',
          dataType: 'component',
          render: () => 'image',
        },
        {
          key: 'createTime',
          label: '创建时间',
          width: 'auto',
          dataType: 'time',
          sortable: 'custom',
        },
        {
          key: 'control',
          label: '操作',
          width: '210px',
          dataType: 'component',
          renderProps: [
            {
              text: '禁用', renderKey: types.COUNSELOR_ENABLE, renderProp: 'valid', eventIndex: 0, disableKey: null,
            },
            {
              text: '启用', renderKey: types.COUNSELOR_DISABLE, renderProp: 'valid', type: 'success', eventIndex: 0, disableKey: null,
            },
            {
              text: '编辑', renderKey: null, type: 'primary', eventIndex: 1, disableKey: null,
            },
            {
              text: '开放审核', renderKey: types.COUNSELOR_NOCHECKVIDEO, type: 'success', eventIndex: 2, renderProp: 'isCheckVideo', disableKey: null,
            },
            {
              text: '收回审核', renderKey: types.COUNSELOR_CHECKVIDEO, eventIndex: 2, renderProp: 'isCheckVideo', disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  mounted() {
    this.getList();
    this.selectList();
  },
  methods: {
    // 新增
    creatOrEdit(item) {
      this.$router.push({ name: 'CounselorCreate', params: { id: item.id } });
    },
    // 获取列表
    async getList(num) {
      this.searchForm.pageNum = num;
      const result = await axClient.counselor.getList(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    async selectList() {
      const all = {
        id: '',
        value: '全部',
      };
      this.agencyList = await axClient.counselor.listAgencyNameByCounselor();
      this.courseList = await axClient.counselor.listNameByCounselor();
      this.courseList = [all, ...this.courseList];
      this.agencyList = [all, ...this.agencyList];
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(pageNum);
    },
    // table sortChange
    sortChange(data) {
      const { prop, order } = data;
      const sortType = {
        createTime: {
          ascending: 50,
          descending: 60,
        },
      };
      this.searchForm.sortType = sortType[prop][order];
      this.getList();
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.confirmDialog(item, true);
          break;
        case 1:
          this.creatOrEdit(item);
          break;
        case 2:
          this.confirmDialog(item, false);
          break;
        default:
          break;
      }
    },
    // 确认使用辅导员抵用券
    confirmDialog(item, type) {
      if (type) {
        this.$confirm('确定禁用/启用该辅导员？', '禁用/启用辅导员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'error',
        }).then(async() => {
          const { id, valid } = item;
          const data = await axClient.counselor.updateValid(
            {
              id,
              valid: valid === types.COUNSELOR_ENABLE
                ? types.COUNSELOR_DISABLE : types.COUNSELOR_ENABLE,
            },
          );
          if (data) {
            this.$message.success('禁用/启用成功');
            this.getList();
          }
        });
      } else {
        this.$confirm('确定收回/开放审核权限？', '收回/开放审核权限', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'error',
        }).then(async() => {
          const { id, isCheckVideo } = item;
          const data = await axClient.counselor.updateCheckVideo(
            {
              id,
              isCheckVideo: isCheckVideo === types.COUNSELOR_CHECKVIDEO
                ? types.COUNSELOR_NOCHECKVIDEO : types.COUNSELOR_CHECKVIDEO,
            },
          );
          if (data) {
            this.$message.success('收回/开放');
            this.getList();
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
